import { withInstall } from '@ll-plus/utils'

import ApiComponent from './src/api-component.vue'

export const LlApiComponent = withInstall(ApiComponent)

export default LlApiComponent

export * from './src/config'

declare module 'vue' {
  export interface GlobalComponents {
    LlApiComponent: typeof ApiComponent
  }
}
